<template>
    <button
        type="button"
        :class="['o-path-steps-item-otg', activeClass]"
        @click="onClick"
    >
        <template v-if="isOutdoorStep">
            <svg-icon
                original
                name="icons/google_maps"
                class="path-step-google-icon"
            />
            <span class="step-text">
                {{ TRANSLATIONS.DESTINATION_STEP_MESSAGE }}
            </span>
        </template>
        <template v-else>
            <div class="step-indicator">
                {{ step.stepIndicator }}
            </div>
            <OStepText
                :step="step"
                class="step-text"
            />
        </template>
    </button>
</template>

<script>
import { mapGetters } from 'vuex'
import { computed } from '@vue/composition-api';

import OStepText from '../../unique-organisms/o-step-text/o-step-text';

export default {
    name: 'OPathStepsItemOtg',
    components: {
        OStepText
    },
    props: {
        step: {
            type: Object,
            required: true
        },
        isOutdoorItem: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: () => ({})
        },
        shouldShowGmapStep: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters([
            't'
        ]),
        destinationStepMessage() {
            return this.t(this.item, 'destination_step_message');
        },
        TRANSLATIONS() {
            return {
                DESTINATION_STEP_MESSAGE: this.$t(this.destinationStepMessage)
            }
        }
    },
    setup(props, { emit }) {
        const activeClass = computed(() => props.step.isActive ? 'path-steps-item-otg-active' : null);
        const isOutdoorStep = computed(() => props.step.isLastStep && props.isOutdoorItem &&  props.shouldShowGmapStep);

        function onClick() {
            emit('onClick', props.step.idx);
        }

        return {
            activeClass,
            isOutdoorStep,
            onClick
        };
    }
}
</script>

<style lang="scss" src="./theme.scss" />